module.exports = __webpack_public_path__ + "static/media/First Lithonia Guide to Eating Healthy on a Budget.49644286.png";